import React from 'react';
import { CheckboxProps } from '@mui/material/Checkbox';
import {
  StyledCheckbox,
  StyledCheckedIcon,
  StyledIcon,
} from './Checkbox.styled';
import { ApproveIcon } from '@theme/icons';

const Checkbox: React.FC<CheckboxProps> = ({ ...rest }) => {
  return (
    <StyledCheckbox
      icon={<StyledIcon />}
      checkedIcon={
        <StyledCheckedIcon>
          <ApproveIcon viewBox="-5 -6 32 32" />
        </StyledCheckedIcon>
      }
      {...rest}
    />
  );
};

export default Checkbox;
